import BigNumber from 'bignumber.js';
import { format } from 'date-fns';
import mixpanel from 'mixpanel-browser';
import { TOKENS, MAX_DECIMALS_DISPLAY } from 'src/constants';

export const rangeFromZero = (len: number) => [...Array(len).keys()];

export const getTokenByAddress = (address: string) => {
  return TOKENS.find((token) => token.address === address);
};

export const getTokenBySymbol = (symbol: string) => {
  return TOKENS.find(
    (token) => token.symbol.toUpperCase() === symbol.toUpperCase()
  );
};

function getNonNegativeZero(value: string) {
  if (value === '-0') {
    return '0';
  }
  return value;
}

export const formatDecimal = (
  value: BigNumber | number | string | bigint,
  options?: {
    maxDecimals?: number;
    thousandsToK?: boolean;
    roundingMode?: BigNumber.RoundingMode;
  }
) => {
  const valueBn = BigNumber(String(value));
  const {
    maxDecimals = MAX_DECIMALS_DISPLAY,
    thousandsToK = true,
    roundingMode,
  } = options || {};

  if (!valueBn.isFinite()) {
    return '--';
  }

  if (valueBn.gte(100000)) {
    if (thousandsToK) {
      return `${valueBn.div(1000).toFormat(0)}k`;
    }

    return valueBn.toFormat(0);
  }

  const formatted = valueBn.toFormat(maxDecimals, roundingMode);

  if (!formatted.includes('.')) {
    return getNonNegativeZero(formatted);
  }

  return getNonNegativeZero(formatted.replace(/0+$/, '').replace(/\.$/, ''));
};

export const formatDate = (date: Date | string | number) => {
  return format(date, 'MMM dd, yyyy, HH:mm:ss');
};

export const shortenAddress = (address: string, chars = 4) => {
  return `${address.slice(0, chars)}...${address.slice(-chars)}`;
};

// https://github.com/s-yadav/react-number-format/blob/7a373b97b1ad240a4a9d21661837518d186bd427/src/utils.tsx#L112
export function fixLeadingZero(numStr?: string) {
  if (!numStr) return numStr;
  const isNegative = numStr[0] === '-';
  if (isNegative) numStr = numStr.substring(1, numStr.length);
  const parts = numStr.split('.');
  const beforeDecimal = parts[0].replace(/^0+/, '') || '0';
  const afterDecimal = parts[1] || '';

  return `${isNegative ? '-' : ''}${beforeDecimal}${afterDecimal ? `.${afterDecimal}` : ''}`;
}

export function trackSCWriteEvent(
  eventName: string,
  _config: any,
  originalGasEstimate?: BigInt
) {
  const config = _config?.request;
  mixpanel.track(eventName, {
    account: config.account.address,
    args: config.args.map(String),
    gas: String(config.gas),
    value: String(config.value),
    originalGasEstimate: String(originalGasEstimate),
  });
}
